// extracted by mini-css-extract-plugin
export default {"noData":"history_entries_list___noData___d4be4dae","entriesList":"history_entries_list___entriesList___a00835f4"};